  import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@mui/material";
import { InsertDriveFile as FileIcon } from "@mui/icons-material";
import CalenderActivity from "./CalenderActivity";
import Styles from "./ActivityComponent.module.css";

import pdfIcon from "../../../assets/SVGs/pdf_icon.svg";

const ActivityComponent = () => {
  const recentActivities = [
    {
      time: "2hrs ago",
      action: "You have uploaded Document.pdf to the Business description",
      filename: "Documentname.pdf",
    },
    {
      time: "2hrs ago",
      action: "You have uploaded Document.pdf to the Business description",
      filename: "Documentname.pdf",
    },
  ];
  return (
    <>
      <div>
        <CalenderActivity />
        <Typography className="quicklinksheding" variant="h6" sx={{ mt: 4, mb: 2, fontWeight: '600', fontFamily: "Avant semibold" , fontSize:"16px"}}>
        Notification
        </Typography>


        <List className={Styles.lastActivityList}>
          <Box className={Styles.lastActivityBox}>
            <Typography className={Styles.lastActivityheading}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_9642_83555)">
<path d="M7.9987 14.6693C11.6806 14.6693 14.6654 11.6845 14.6654 8.0026C14.6654 4.32071 11.6806 1.33594 7.9987 1.33594C4.3168 1.33594 1.33203 4.32071 1.33203 8.0026C1.33203 11.6845 4.3168 14.6693 7.9987 14.6693Z" stroke="#FB3737" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 5.33594V8.0026" stroke="#FB3737" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 10.6641H8.0075" stroke="#FB3737" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_9642_83555">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg> Action Needed</Typography>
            <Typography className={Styles.lastActivitytext}>Join the calibration meetings!</Typography>
          </Box>
          {/* {recentActivities.map((activity, index) => (
            <React.Fragment key={index}>
              <ListItem alignItems="flex-start">
                <ListItemIcon>
                  <div className={Styles.iconBox}>
                    <FileIcon />
                  </div>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography component="span" variant="body2" color="#667085">
                      {activity.time}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography sx={{
                        fontWeight: '400', fontFamily: "Avantt" , fontSize:"14px"
                      }} component="span" variant="body1" color="#000">
                        {activity.action}
                      </Typography>
                      <br />
                      <div className={Styles.docDiv}>
                        <div>
                          <img src={pdfIcon} alt="" height={25} width={25} />
                        </div>
                        <div>
                         <h4>Documentname.pdf</h4> 
                         <p>03-02-2024</p>
                        </div>

                      </div>
                    </>
                  }
                />
              </ListItem>
              {index < recentActivities.length - 1 && (
                <Divider variant="inset" component="li" />
              )}
            </React.Fragment>
          ))} */}
        </List> 
      </div>
    </>
  );
};

export default ActivityComponent;
